// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3B1mB","savePackageButton":"ClientWallet_savePackageButton__3ZFws"};